import { PresenceListComponent } from './presence-list.component';
export default PresenceListComponent;
